import { render, staticRenderFns } from "./DodCustomRadioInput.vue?vue&type=template&id=21eda264&scoped=true&"
import script from "./DodCustomRadioInput.vue?vue&type=script&lang=js&"
export * from "./DodCustomRadioInput.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomRadioInput.vue?vue&type=style&index=0&id=21eda264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eda264",
  null
  
)

export default component.exports